import React from 'react';
import { useState } from 'react';
import {
  AlertTriangle,
  Eye,
  XCircle,
  BookOpen,
  ArrowRight,
  Timer,
  Keyboard,
  Target,
  CircleAlert,
  Zap
} from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const TypingTestInstructions = () => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const { interview_id } = useParams();
  const [hasAgreed, setHasAgreed] = useState(false);

  const {whitelabelEnabled} = useSelector((state)=>state.miscSlice)
  // const whitelabelEnabled = true

  const instructions = [
    { icon: <CircleAlert />, text: "Type each word just as you see it on the screen." },
    { icon: <Keyboard />, text: "Press Space or Enter to submit every word." },
    { icon: <Timer />, text: "The test will finish on its own when the timer ends." },
    { icon: <Eye />, text: "Try to focus on accuracy first, then gradually increase your speed." },
    { icon: <AlertTriangle />, text: "Please stay on the test page and avoid switching tabs." },
    { icon: <XCircle />, text: "Copy-paste isn't allowed, so type everything manually." },
    { icon: <BookOpen />, text: "Please don't use any external help or typing tools during the test." }
  ];

  return (
    <div className={`min-h-screen flex ${ whitelabelEnabled
          ? "bg-[#FAF9F6]"
          : ""} `}>
      {/* Left Section */}
      <div className="w-5/12 p-8 flex flex-col justify-center items-center text-white">
        <div className="max-w-lg space-y-12">
          <div className="text-center mb-12">
            <h1 className={`text-4xl font-bold mb-6 ${whitelabelEnabled ? 'text-slate-900':'bg-gradient-to-r from-[#69007f] to-[#fc0987] text-transparent bg-clip-text'} `}>Ready to Test Your Typing Skills?</h1>
            <p className={`text-lg opacity-90 ${whitelabelEnabled ? 'text-gray-700':'text-gray-100'}`}>Demonstrate your typing speed and accuracy in this timed assessment</p>
          </div>

          <div className="grid grid-cols-2 gap-8">
          </div>
        </div>
      </div>

      {/* Right Section - Instructions */}
      <div className="w-7/12 p-4">
        <div className="max-w-2xl mx-auto">
          <div className={`rounded-2xl p-8 ${whitelabelEnabled ? "bg-white shadow-sm":'shadow-xl glass-effect backdrop-blur-lg '}`}>
            <h2 className={`text-3xl font-bold text-center mb-8 ${whitelabelEnabled ? 'text-slate-900':'bg-gradient-to-r from-[#69007f] to-[#fc0987] text-transparent bg-clip-text'}`}>
              Test Instructions
            </h2>

            <div className="space-y-4">
              {instructions.map((instruction, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-2 rounded-lg"
                >
                  <div className={`w-6 h-6 ${whitelabelEnabled ? 'text-[#1569c4]':'text-pink-500'} mt-1 flex-shrink-0`}>
                    {instruction.icon}
                  </div>
                  <p className={`${whitelabelEnabled ? 'text-gray-700':'text-gray-300'}`}>
                    {instruction.text}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-6 flex items-center gap-2 justify-center">
              <input
                type="checkbox"
                id="agreement"
                checked={hasAgreed}
                onChange={(e) => setHasAgreed(e.target.checked)}
                className="w-4 h-4 text-pink-500 rounded focus:ring-pink-500"
              />
              <label htmlFor="agreement" className={`${whitelabelEnabled ? 'text-gray-600':'text-gray-300'} text-sm`}>
                I have read and agree to follow all the instructions
              </label>
            </div>

            <div className="mt-8 text-center">
              {hasAgreed && (
                <button
                  onClick={() => navigate(`/candidate/typingtest/${interview_id}`)}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  className={` group relative px-8 py-3 text-white  font-semibold -lg transform transition-all duration-300 hover:scale-105 ${whitelabelEnabled ? 'bg-[#1569c4] px-5 py-2.5 rounded-full cursor-pointer text-[15px]':'button hover:shadow-lg'} inline-flex items-center gap-2`}
                >
                  <span className="flex gap-2">
                    Proceed to Test
                    <ArrowRight className={`w-5 h-5 transition-transform duration-300 ${isHovered ? 'translate-x-1' : ''}`} />
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingTestInstructions;
